import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchCampaignsFilterEntity } from '../../domain/entities/BranchCampaignsFilterEntity'

export class BranchCampaignsFilterModel extends BranchCampaignsFilterEntity {
  constructor(dataDto: BranchCampaignsFilterEntity) {
    super()
    mapEntityProperties<BranchCampaignsFilterEntity>(this, dataDto)
  }
}
